import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { applyMask } from "@/utilities/mask";
import styles from './search.module.scss';

export function Search(props) {
  const {
    type,
    className,
    placeholder,
    onChange,
    value,
    autoComplete,
    handleOnSubmit,
    mask,
    unmasked,
  } = props;

  const [isFocus, setFocus] = useState(false);

  function handleOnChange({ target }) {
    const { value: newValue } = target;

    let result = newValue;

    if (mask) {
      const maskedResult = applyMask({ mask, value: newValue });

      result = unmasked ? maskedResult.unmasked : maskedResult.masked;
    }

    if (onChange) {
      onChange(result);
    }
  }

  function handleSelectAutoCompleteItem(item) {
    setFocus(false);

    if (onChange) {
      onChange(item);
    }
  }

  function handlesubmit(e) {
    e.preventDefault();

    if (handleOnSubmit) {
      handleOnSubmit();
    }
  }

  return (
    <div>
      <Form className={styles.searchBar} onSubmit={handlesubmit}>
        <Form.Control
          type={type}
          placeholder={placeholder}
          className={className}
          onChange={handleOnChange}
          value={value}
          onFocus={() => setFocus(true)}
          onBlur={() => {
            setTimeout(() => {
              setFocus(false);
            }, 250);
          }}
        />
      </Form>

      {isFocus && autoComplete && (
        <ul className={styles.autoCompleteList}>
          {autoComplete.slice(0,5).map((item, index) => (
            <li
              key={index}
              className={styles.autoCompleteItem}
              onClick={() => handleSelectAutoCompleteItem(item)}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

Search.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  handleOnSubmit: PropTypes.func,
  autoComplete: PropTypes.array,
  mask: PropTypes.string,
  unmasked: PropTypes.bool
};
